module.exports = __webpack_public_path__ + "img/2. New developments-en.0013506.png";